export const COMPETITIONS_10_S = [
    '10s - Crveni',
    '10s - Narandžasti',
    '10s - Zeleni',
]
